import { all } from 'redux-saga/effects';
import getTableWatcher from '../../tables/sagas/tablesSaga';
import userWatcher from '../../user/redux/sagas/UserSaga';
import doImpcEditWatcher from '../../../application/impc-edit/redux/sagas/impcEditSaga';
import doThresholdEditWatcher from '../../../application/yearly-thresholds/bulk-edit/redux/sagas/weeklyThresholdsEditSaga';
import doMpaTransactionsEditWatcher from '../../../application/impc-stock-levels/transactions/manual-preadvice/edit/redux/sagas/manualPreadviceTransactionsEditSaga';
import doRepatriationsTransactionsEditWatcher from '../../../application/impc-stock-levels/transactions/internal-repatriations/edit/redux/sagas/RepatriationsTransactionsEditSagas';
import doBOHTransactionsEditWatcher from '../../../application/impc-stock-levels/transactions/balance-modification/edit/redux/sagas/BalanceModificationTransactionsEditSagas';
import doBOHTransactionsCreateWatcher from '../../../application/impc-stock-levels/transactions/balance-modification/create/redux/sagas/BalanceModificationTransactionsCreateSagas';
import doMpaTransactionsCreateWatcher from '../../../application/impc-stock-levels/transactions/manual-preadvice/create/redux/sagas/ManualPreadviceTransactionsCreateSagas';
import doInternalRepatriationsTransactionsCreateWatcher
  from '../../../application/impc-stock-levels/transactions/internal-repatriations/create/redux/sagas/InternalRepatriationsTransactionsCreateSagas';
import doCenterInitiatedRepatriationsTransactionsCreateWatcher
  from '../../../application/impc-stock-levels/transactions/internal-repatriations/create/redux/sagas/CenterInitiatedRepatriationsCreateSagas';
import doMpaTransactionsDeleteWatcher from '../../../application/impc-stock-levels/transactions/manual-preadvice/delete/redux/sagas/ManualPreadviceTransactionsDeleteSagas';
import doBohTransactionsDeleteWatcher from '../../../application/impc-stock-levels/transactions/balance-modification/delete/redux/sagas/BalanceModificationTransactionsDeleteSagas';
import doRepatriationsTransactionsDeleteWatcher from '../../../application/impc-stock-levels/transactions/internal-repatriations/delete/redux/sagas/InternalRepatriationsTransactionsDeleteSagas';
import doRepatriationsTransactionsExecuteWatcher from '../../../application/impc-stock-levels/transactions/internal-repatriations/execute/redux/sagas/RepatriationsTransactionsExecuteSagas';
import doRepatriationsTransactionsObjectWatcher from '../../../application/impc-stock-levels/transactions/internal-repatriations/object/redux/sagas/RepatriationsTransactionsObjectSagas';
import doRepatriationsTransactionsConfirmWatcher from '../../../application/impc-stock-levels/transactions/internal-repatriations/confirm/redux/sagas/RepatriationsTransactionsConfirmSagas';
import doPredesTransactionsRejectWatcher from '../../../application/impc-stock-levels/transactions/predes/reject/redux/sagas/PredesTransactionsRejectSagas';
import doPredesTransactionsReleaseWatcher from '../../../application/impc-stock-levels/transactions/predes/release/redux/sagas/PredesTransactionsReleaseSagas';
import doMpaTransactionsApplyWatcher from '../../../application/impc-stock-levels/transactions/manual-preadvice/apply/redux/sagas/ManualPreadviceTransactionsApplySagas';
import doMemberPoolStorageEditWatcher from '../../../application/member-pool-storage/redux/sagas/MemberPoolStorageEditSagas';
import doRouteCreateWatcher from '../../../application/route-management/create/redux/sagas/RouteManagementCreateSagas';
import doRouteEditWatcher from '../../../application/route-management/edit/redux/sagas/EditRouteSagas';
import doRfidFileDeleteWatcher from '../../../application/rfid-file-management/delete/redux/sagas/RfidFileDeleteSagas';
import doRfidFileUploadWatcher from '../../../application/rfid-file-management/upload/redux/sagas/RfidFileUploadSagas';
import doRfidFileDownloadWatcher from '../../../application/rfid-file-management/download/redux/sagas/RfidFileDownloadSagas';
import doEdiRfidAuditExecutionDeleteWatcher from '../../../application/edi-rfid-audit/execution/delete/redux/sagas/EdiRfidAuditExecutionDeleteSagas';
import doEdiRfidAuditDeleteWatcher from '../../../application/edi-rfid-audit/request/delete/redux/sagas/EdiRfidAuditDeleteSagas';
import doEdiRfidAuditCreateWatcher from '../../../application/edi-rfid-audit/request/create/redux/sagas/EdiRfidAuditRequestCreateSagas';
import doImpcsOfSingleOperatorApplyWatcher from '../../selection-criteria/impcs-per-operator/redux/sagas/ImpcsOfSingleOperatorSagas';
import doDailyRouteLeadingCountUseEdiOrMaxWatcher from '../../../application/daily-route-leading-count-status/use-edi-or-max/redux/sagas/DailyRouteLeadingCountUseEdiOrUseMaxSagas';
import doBalanceOnHandThresholdEditWatcher from '../../../application/impc-stock-levels/impc-characteristics/boh-thresholds/edit/redux/sagas/BalanceOnHandThresholdsEditSagas';
import doSavePoolMembershipManagementWatcher
  from '../../../application/pool-membership-management/redux/sagas/PoolMembershipManagementSagas';
import doPredesTransactionsObjectWatcher from '../../../application/impc-stock-levels/transactions/predes/object/redux/sagas/PredesTransactionsObjectSagas';
import doPredesTransactionsEditWatcher from '../../../application/impc-stock-levels/transactions/predes/edit/redux/sagas/PredesTransactionsEditSaga';
import doGlobalPresetApplyWatcher
  from '../../selection-criteria/global-preset/redux/sagas/GlobalPresetPerAssetTypeSagas';
import doRecalculateTaskCreateWatcher
  from '../../../application/recalculate-tasks/create/redux/sagas/RecalculateTasksCreateSagas';

function* rootSaga() {
  yield all([
    getTableWatcher(),
    userWatcher(),
    doImpcEditWatcher(),
    doThresholdEditWatcher(),
    doMpaTransactionsEditWatcher(),
    doRepatriationsTransactionsEditWatcher(),
    doBOHTransactionsEditWatcher(),
    doBOHTransactionsCreateWatcher(),
    doMpaTransactionsCreateWatcher(),
    doInternalRepatriationsTransactionsCreateWatcher(),
    doCenterInitiatedRepatriationsTransactionsCreateWatcher(),
    doMpaTransactionsDeleteWatcher(),
    doBohTransactionsDeleteWatcher(),
    doRepatriationsTransactionsDeleteWatcher(),
    doRepatriationsTransactionsExecuteWatcher(),
    doRepatriationsTransactionsObjectWatcher(),
    doRepatriationsTransactionsConfirmWatcher(),
    doPredesTransactionsRejectWatcher(),
    doPredesTransactionsReleaseWatcher(),
    doMpaTransactionsApplyWatcher(),
    doMemberPoolStorageEditWatcher(),
    doRouteCreateWatcher(),
    doRouteEditWatcher(),
    doRfidFileDeleteWatcher(),
    doRfidFileUploadWatcher(),
    doRfidFileDownloadWatcher(),
    doEdiRfidAuditExecutionDeleteWatcher(),
    doEdiRfidAuditDeleteWatcher(),
    doEdiRfidAuditCreateWatcher(),
    doImpcsOfSingleOperatorApplyWatcher(),
    doDailyRouteLeadingCountUseEdiOrMaxWatcher(),
    doBalanceOnHandThresholdEditWatcher(),
    doSavePoolMembershipManagementWatcher(),
    doPredesTransactionsObjectWatcher(),
    doPredesTransactionsEditWatcher(),
    doGlobalPresetApplyWatcher(),
    doRecalculateTaskCreateWatcher(),
  ]);
}

export default rootSaga;
